import { render, staticRenderFns } from "./TitlesImg.vue?vue&type=template&id=2158b6a9&scoped=true&"
import script from "./TitlesImg.vue?vue&type=script&lang=js&"
export * from "./TitlesImg.vue?vue&type=script&lang=js&"
import style0 from "./TitlesImg.vue?vue&type=style&index=0&id=2158b6a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2158b6a9",
  null
  
)

export default component.exports